import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import useItemsSetter from 'recoil/useItemsSetter'
import protectionTableAtom from '../ProtectionTable.atom'
import { useCallback } from 'react'
import eventBus from 'services/eventBus'
import useTableWithRequest from 'shared/Table/useTableWithRequest'
import ProtectionTableFields from '../ProtectionTable.fields'
import { IProtectionTemplate } from '../../protection.types'
import Table from 'shared/Table'
import protectionTemplateApi from '../../protection.api'

const ProtectionTemplatesTable = () => {
  const state = useRecoilValue(protectionTableAtom)
  const navigate = useNavigate()
  const itemsSetter = useItemsSetter(protectionTableAtom)

  useEffect(() => {
    const unsub = eventBus.sub('protectionTemplate.updated', ({ id, updates }) => {
      itemsSetter((prevItems) => prevItems.map((item) => (item.id === id ? { ...item, ...updates } : item)))
    })
    return unsub
  }, [itemsSetter])

  const fetcher = useCallback((params: Record<string, any>) => {
    return protectionTemplateApi.getProtectionTemplates(params)
  }, [])

  const tableCtrl = useTableWithRequest({
    dataFetcher: fetcher,
    fields: ProtectionTableFields,
    itemKey: 'id',
    items: state.items,
    setItems: itemsSetter,
    tableKey: 'protection-templates',
  })

  const handleClick = useCallback((val: IProtectionTemplate) => {
    navigate(`/admin/protection-templates/${val.id}`)
  }, [])

  return (
    <Table
      {...tableCtrl}
      items={tableCtrl.orderedItems}
      handleSelect={tableCtrl.selectedCtrl.setSelected}
      selected={tableCtrl.selectedCtrl.selectedIndexes as Set<keyof IProtectionTemplate>}
      handleSelectAll={tableCtrl.selectedCtrl.setSelectAll}
      itemKey='id'
      onCLick={handleClick}
      selectEnabled={false}
    />
  )
}

export default ProtectionTemplatesTable
